import { debounce } from 'lodash'
import { getYunPanFileMeta } from '@remote/api/adapter/xos-mqtt'
import { getErrorMessage } from '@remote/utils/base'
import { checkState } from '@remote/store/utils'
import { isImageFile, isVideoFile, isAudioFile } from '@remote/utils/file-helper'
import { toast, openFileProcessor } from '@remote/utils/dialog'
import { isAndroidHezi, isIOSHezi } from '@remote/utils/platform'
import { androidBridge, callByJson, ICallByJsonParams } from '@remote/utils/jsbridge/hezi'
import iOSBridge from '@remote/utils/jsbridge/hezi/ios'
import type { TProvider } from '@remote/api/adapter/xos-mqtt'
import type { IYunPanFileInfo } from '@remote/type/yunpan'

export function isSupportPreview (fileName) {
  return isImageFile(fileName) || isVideoFile(fileName) || isAndroidHezi && isAudioFile(fileName)
}

export function getAndroidPreviewParams (file: IYunPanFileInfo): ICallByJsonParams | void {
  if (isVideoFile(file.name)) return {
    router: 'video/play',
    params: {
      xPanId: file.id,
      fileName: file.name,
    },
  }
  if (isAudioFile(file.name)) return {
    router: 'audio/play',
    params: {
      x_pan_file_ids: [file.id],
      fileName: file.name,
    },
  }
  if (isImageFile(file.name)) return {
    router: 'preview/image/xpan',
    params: {
      xPanParentId: file.parent_id || '',
      xPanImageId: file.id,
      fileName: file.name,
    },
  }
}

export const previewFile = debounce(function viewFile (file: IYunPanFileInfo, provider: TProvider) {
  if (checkState(true, true, false, false)) return
  if (isSupportPreview(file.name)) {
    if (isAndroidHezi) {
      const params = getAndroidPreviewParams(file)
      console.log('callByJson params', params)
      if (params) {
        callByJson(params)
      } else {
        toast('播放异常，请稍后重试')
      }
    } else if (isIOSHezi) {
      toast('功能待开发')
    } else {
      getYunPanFileMeta({
        provider,
        file_id: file.id,
      }).then(data => {
        console.log('[PanList]', '[preview]当前文件详情:', data)
        if (!data) {
          toast({ type: 'error', message: '文件不存在' })
          return
        }
        const ext = data.name.split('.').slice(-1)
        const mime_type = isImageFile(file.name) ? 'image/*' : `video/${ext}`
        return openFileProcessor({
          isShowPreviewFileComp: true,
          previewFileInfo: { ...data, fileExtension: ext, mime_type },
        })
      }).catch(err => {
        console.error(err)
        const msg = getErrorMessage(err)
        toast({ type: 'error', message: msg })
      })
    }
  } else {
    toast({ type: 'warn', message: '暂不支持打开' })
  }
}, 2000, {
  leading: true,
  trailing: false,
})

interface ILinkInfo {
  url: string
  name: string
  icon: string
  fileType: 'folder' | 'file'
}
export async function addDownloadTaskByNative (links: ILinkInfo[], downloadPath: string) {
  const taskList = links.map(link => {
    const { url, name, fileType } = link
    return {
      url,
      name,
      downloadPath,
      isFromCloud: true,
      is_folder: fileType === 'folder',
    }
  })
  if (isAndroidHezi) {
    return new Promise((resolve, reject) => {
      androidBridge.callHandler('callByJsonWithCallback', JSON.stringify({
        router: 'dl/action/add_download',
        params: {
          data: JSON.stringify(taskList),
        },
      }), (err, response: { code: number; msg?: string }) => {
        console.log('[callByJsonWithCallback][download]:', err, typeof response, response)
        if (err) {
          reject(err)
        } else {
          if (response.code === 0) {
            resolve(true)
          } else {
            reject(new Error(response.msg))
          }
        }
      })
    })
  } else if (isIOSHezi) {
    return new Promise((resolve, reject) => {
      console.log('[addHeziDownloadTasks][check][call]')
      iOSBridge.checkFunction('addHeziDownloadTasks', ({ exist }) => {
        console.log('[addHeziDownloadTasks][check][result]:', exist)
        if (!exist) {
          return reject(new Error('暂不支持该方法(addHeziDownloadTasks)'))
        }
        console.log('[addHeziDownloadTasks][call]:', taskList)
        iOSBridge.callHandler('addHeziDownloadTasks', {
          data: taskList,
        }, (err, response: { code: number; msg?: string }) => {
          console.log('[addHeziDownloadTasks][response]:', err, response)
          if (err) {
            reject(err)
          } else {
            if (response.code === 0) {
              resolve(true)
            } else {
              reject(new Error(response.msg))
            }
          }
        })
      })
    })
  } else {
    return Promise.reject(new Error('请在客户端环境下调用'))
  }
}
